module.exports = __webpack_public_path__ + "r.no2.87b5101f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/r.no2.jpg
// module id = CaGz
// module chunks = 0